import { styled } from '@mui/system';

const DevExCellContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '16px',
    height: '400px',
    '@media (max-width: 1024px)': {
        height: 'auto',
        minHeight: '300px',
        gap: '12px',
        marginBottom: '24px',
    }
});

const DevExCellTitle = styled('h2')({
    color: '#F1F7F7',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '24px',
    marginBottom: '8px',
    whiteSpace: 'nowrap',
    '@media (max-width: 1024px)': {
        fontSize: '24px',
        lineHeight: '32px',
        whiteSpace: 'normal',
    }
});

const DevExCellIcon = styled('img')({
    width: '48px',
    height: '48px',
    '@media (max-width: 1024px)': {
        width: '40px',
        height: '40px',
    }
});

interface DevExCellProps {
    icon: string;
    title: string;
    children: React.ReactNode;
}

export const DevExCell = ({ icon, title, children }: DevExCellProps) => {
    return (
        <DevExCellContainer>
            <DevExCellIcon src={icon} alt={title} />
            <DevExCellTitle>{title}</DevExCellTitle>
            {children}
        </DevExCellContainer>
    );
};
